import { apiService } from '../../..'
import { EnabledCardsResponse } from '../types'

export const enabledCardsService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getEnabledCards: build.query<EnabledCardsResponse, void>({
      query: () => {
        return {
          url: '/portal/consumers/enabled-cards',
          method: 'GET',
        }
      },
    }),
  }),
})
